import getFsVPath from './FSValidationCompositionAPI'

export default {
  computed: {
    $fsV () {
      return getFsVPath(this.$attrs)
    }
  }
}
